@for (item of menu; track trackMenuItemsFn($index, item)) {
  @if (isMenuItemVisible(item)) {
    <kendo-panelbar [appWIPHide]="item.wip === true" [appAnalyticsHide]="item.analytics === true">
      <kendo-panelbar-item
        (click)="onMenuItemExpand(item, !item.selected)"
        title="{{ item.title | translate }}"
        [expanded]="item.selected === true"
      >
        <ng-template kendoPanelBarItemTitle>
          <div [appWIPHide]="item.wip === true">
            <!-- TODO: Na .menu-icon-wrapper pridat ".active", kdyz bude subitem aktivní -->
            @if (item.icon) {
              <span class="menu-icon-wrapper" [class.active]="anySubActive(item) && !item.selected">
                <mat-icon svgIcon="{{ item.icon }}" class="menu-icon"></mat-icon>
              </span>
            }
            <!-- TODO: Na .title pridat ".active", kdyz bude subitem aktivní -->
            <span class="title" [class.active]="anySubActive(item) && item.selected == false">
              {{ item.title | translate }}
            </span>
          </div>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <ul>
            @for (subItem of item.items; track subItem) {
              @if (isSubMenuItemVisible(subItem)) {
                <li
                  [appWIPHide]="subItem.wip === true"
                  [appAnalyticsHide]="subItem.analytics === true"
                  (click)="$event.stopPropagation()"
                  class="menu-item-main menu-item"
                  routerLinkActive="menu-item-selected"
                  [attr.data-cy]="'menu-' + subItem.path + '_button'"
                  [routerLink]="subItem.path"
                >
                  <span class="menu-text" [translate]="subItem.title"> </span>
                </li>
              }
            }
          </ul>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  }
  @if (isMenuItemVisible(item)) {
    <div class="divider"></div>
  }
}

<footer>
  <app-copyright />
</footer>
